/** @component radio */
import React from 'react';
import { Label } from "./..";

var Radio = function Radio(props) {
  var checked = props.checked,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      htmlId = props.htmlId,
      inputRef = props.inputRef,
      label = props.label,
      name = props.name,
      nestedLevel = props.nestedLevel,
      onChange = props.onChange,
      required = props.required,
      tabIndex = props.tabIndex,
      value = props.value;
  return React.createElement("div", {
    className: 'md-input-container md-radio' + ("" + (nestedLevel && " md-input--nested-" + nestedLevel || '')) + (" " + className)
  }, React.createElement("input", {
    className: 'md-input md-radio__input',
    type: "radio",
    ref: inputRef,
    disabled: disabled,
    checked: checked,
    required: required,
    name: name,
    value: value,
    id: htmlId,
    onChange: onChange,
    tabIndex: tabIndex
  }), React.createElement(Label, {
    className: "md-radio__label",
    label: label,
    htmlFor: htmlId
  }), children);
};

Radio.defaultProps = {
  checked: false,
  children: null,
  className: '',
  disabled: false,
  inputRef: null,
  label: '',
  name: '',
  nestedLevel: 0,
  onChange: function onChange() {},
  required: false,
  tabIndex: 0,
  value: ''
};
Radio.displayName = 'Radio';
export default Radio;